import { render } from "./LoaderRing.vue?vue&type=template&id=83c4b7f6"
const script = {}

import "./LoaderRing.vue?vue&type=style&index=0&id=83c4b7f6&lang=scss"

import exportComponent from "/Users/gardener/OpenideProjects/Navigator_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__